/*
 * Copyright (c) 2022.
 * ISNLab
 * Owner and rewriter: Sedov A. Sergey
 * sedov.sergey@isnlab.com
 */

import {createRouter, createWebHistory} from 'vue-router';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ResetPage from "./pages/ResetPage";
import IndexPage from "./pages/IndexPage";
import NotFoundPage from "@/pages/NotFoundPage";

export const router = createRouter({
    history: createWebHistory(),
    linkActiveClass: "active",
    linkExactActiveClass: "exact-active",
    routes: [
        {
            path: '/member/',
            redirect: '/member/index',
        },
        {
            name: 'Index',
            path: '/member/index',
            component: IndexPage,
            meta: {
                title: 'Overview',
                requiresAuth: true
            }
        },
        {
            name: 'Login',
            path: '/member/login',
            component: LoginPage,
            meta: {
                title: 'Log in',
            }
        },
        {
            name: 'Signup',
            path: '/member/signup',
            component: SignupPage,
            meta: {
                title: 'Sign up',
            }
        },
        {
            name: 'NotFound',
            path: '/member/notfound',
            component: () => import(/* webpackChunkName: "notfound" */ './pages/NotFoundPage.vue'),
            meta: {
                title: 'Page not found',
            }
        },
        {
            name: 'Reset',
            path: '/member/reset',
            component: ResetPage,
            meta: {
                title: 'Reset password',
            }
        },
        {
            name: 'Limits',
            path: '/member/limits',
            component: () => import(/* webpackChunkName: "settings/limits" */ './pages/settings/LimitsPage.vue'),
            meta: {
                title: 'Limits',
                requiresAuth: true
            },
        },
        {
            name: 'Streams',
            path: '/member/streams',
            component: () => import(/* webpackChunkName: "settings/stream" */ './pages/streams/StreamsPage.vue'),
            meta: {
                title: 'Streams List',
                requiresAuth: true
            },
        },
        {
            name: 'Offers',
            path: '/member/offers',
            component: () => import(/* webpackChunkName: "settings/offers" */ './pages/settings/OffersPage.vue'),
            meta: {
                title: 'Offers',
                requiresAuth: true
            },
        },
        {
            name: 'Postback',
            path: '/member/postback',
            component: () => import(/* webpackChunkName: "settings/postback" */ './pages/settings/PostbackPage.vue'),
            meta: {
                title: 'Postback',
                requiresAuth: true
            },
        },
        {
            name: 'Earnings',
            path: '/member/earnings',
            component: () => import(/* webpackChunkName: "detail/earning" */ './pages/details/EarningDetailsPage.vue'),
            meta: {
                title: 'Earnings',
                requiresAuth: true
            },
        },
        {
            name: 'Balance',
            path: '/member/balance',
            component: () => import(/* webpackChunkName: "detail/bal" */ './pages/details/BalanceDetailsPage.vue'),
            meta: {
                title: 'Balance',
                requiresAuth: true
            },
        },
        {
            name: 'Withdraws',
            path: '/member/whistory',
            component: () => import(/* webpackChunkName: "detail/withdraw" */ './pages/details/WithdrawHistoryPage.vue'),
            meta: {
                title: 'Withdraws',
                requiresAuth: true
            },
        },
        {
            name: 'Profile',
            path: '/member/profile',
            component: () => import(/* webpackChunkName: "profile" */ './pages/ProfilePage.vue'),
            meta: {
                title: 'Profile',
                requiresAuth: true
            },
        },
        {
            name: 'Messages',
            path: '/member/messages',
            component: () => import(/* webpackChunkName: "profile" */ './pages/ProfilePage.vue'),
            meta: {
                title: 'Profile',
                requiresAuth: true
            },
        },
        {
            name: 'Promo',
            path: '/member/promo',
            component: () => import(/* webpackChunkName: "promo" */ './pages/PromoPage.vue'),
            meta: {
                title: 'Promo materials',
                requiresAuth: true
            },
        },
        {
            name: 'Program',
            path: '/member/program',
            component: () => import(/* webpackChunkName: "program" */ './pages/ProgramPage.vue'),
            meta: {
                title: 'Affiliate Program',
                requiresAuth: true
            },
        },
        {
            name: 'Withdraw',
            path: '/member/withdraw',
            component: () => import(/* webpackChunkName: "withdraw" */ './pages/WithdrawPage.vue'),
            meta: {
                title: 'Withdraw Money',
                requiresAuth: true
            },
        },
        {
            name: 'NotApproved',
            path: '/member/notapproved',
            component: () => import(/* webpackChunkName: "notapproved" */ './pages/NotApprovedPage.vue'),
            meta: {
                title: 'User Not Approved',
                requiresAuth: true
            },
        },
        {
            name: 'Blocked',
            path: '/member/blocked',
            component: () => import(/* webpackChunkName: "blocked" */ './pages/BlockedPage.vue'),
            meta: {
                title: 'User Blocked',
                requiresAuth: true
            },
        },
        {
            name: '404',
            path: '/:pathMatch(.*)*',
            component: NotFoundPage,
            meta: {
                title: 'Page not found',
                requiresAuth: false
            },
        },
/*        {
            name: 'book-form',
            path: '/book/edit/:bookId?',
            component: BookForm,
            props: true,
            alias: '/book/add'
        },
        {
            name: 'book-item',
            path: '/book/:bookId(\\d+)',
            component: BookItem,
            props: true
        },
*/
    ],
    scrollBehavior() {
        document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
    }
});
